import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/Card';
import { cn } from '../../lib/utils';
import { useTheme } from '../../context/ThemeContext';

export function DistributionSummary({ items = [], className }) {
  const { chartPalette } = useTheme();

  return (
    <Card className={cn('min-w-0', className)}>
      <CardHeader className="px-4 py-2.5">
        <CardTitle>Headline shares</CardTitle>
      </CardHeader>
      <CardContent className="space-y-3 px-4 py-3">
        {items.map((item, index) => (
          <div key={item.id}>
            <div className="flex items-center justify-between gap-3 text-xs">
              <p className="min-w-0 text-slate-600">{item.label}</p>
              <p className="shrink-0 font-bold tabular-nums text-[#201C35]">
                {(item.value * 100).toFixed(0)}%
              </p>
            </div>
            <div className="mt-1.5 h-1.5 overflow-hidden rounded-full bg-slate-100">
              <div
                className="h-full rounded-full"
                style={{
                  width: `${Math.max(item.value * 100, 2)}%`,
                  backgroundColor: chartPalette[index % chartPalette.length],
                }}
              />
            </div>
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
